import {nextTick} from "petite-vue";

interface PhoneCodeInput {
    list: { [key: string]: string }
    code: string
    selected: string
    readonly isCustom: boolean
    changePhoneCode(e: Event): void
    closeDropdown(e: FocusEvent): void
    watchPhoneInput(): void
}

export default function (props: { list: { [key: string]: string }, code: string | null }): PhoneCodeInput {
    return {
        list: props.list ?? {},
        code: props.code ?? (Object.values(props.list)[0] ?? "+420"),
        selected: !props.code ? (Object.keys(props.list)[0] ?? "CZ")
            : Object.keys(props.list).find(key => props.list[key] === props.code),
        get isCustom() {
            return this.selected === 'custom'
        },
        async changePhoneCode(e) {
            const target = e.target as HTMLElement
            if (!target.dataset?.key) return

            this.selected = target.dataset.key
            this.code = !this.isCustom ? target.dataset.code : ""

            let parent = target.closest('details') as HTMLElement
            if (!this.isCustom) parent = parent.parentElement

            // @ts-ignore
            await nextTick();
            (parent.nextElementSibling as HTMLInputElement).focus()
        },
        closeDropdown(e) {
            const details = this.$refs.dropdown as HTMLDetailsElement
            if (!details.contains(e.relatedTarget as Node)) details.open = false
        },
        watchPhoneInput() {
            // TODO: navázat přímo na input v komponentě
            let phoneInput = document.querySelector('input[name="your-phone"]') as HTMLInputElement
            if (!phoneInput) phoneInput = document.querySelector('input[name="phone"]') as HTMLInputElement

            phoneInput?.addEventListener("keypress", (e: KeyboardEvent) => {
                (isNaN(e.key) || (!e.code.startsWith("Digit") && !e.code.startsWith("Numpad")) || e.code === "Space") && e.preventDefault()
            });

            phoneInput?.addEventListener('input', () => {
                if (phoneInput.value.length < 3 || !phoneInput.value.startsWith("+")) return

                let matchingCode = false
                Object.values(this.list).forEach((code: string, index) => {
                    if (phoneInput.value.startsWith(code)) {
                        this.code = code
                        this.selected = Object.keys(this.list)[index]
                        matchingCode = true
                    }
                })

                if (!matchingCode && phoneInput.value.length > 3) {
                    this.selected = 'custom'
                    this.code = ""
                }
            })

            phoneInput?.addEventListener('change', () => {
                phoneInput.value = phoneInput.value.replaceAll(' ', '')
            })
        }
    }
}
